import { useLayoutEffect } from 'preact/hooks';
import { ON_SERVER } from '../consts.js';

export default function useViewportRelation(callback, ref, active) {
  function viewportRelation() {
    if (ON_SERVER && active) {
      callback();
    }

    const element = ref.current;

    if (!active || element == null) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    function forEachEntry(intersectionEntry) {
      if (intersectionEntry.isIntersecting) {
        callback();
        cleanup();
      }
    }

    function onEntries(entries) {
      entries.forEach(forEachEntry);
    }

    const observer = new IntersectionObserver(onEntries, {
      threshold: [0.1],
      rootMargin: '1px',
    });

    observer.observe(element);

    function cleanup() {
      observer.unobserve(element);
      observer.disconnect();
    }

    return cleanup;
  }

  useLayoutEffect(viewportRelation, [ref, callback, active]);
}
